import { sendCancelToExternal, sendCancelToInternal } from "../mail/sendCancel";
import { convertDate, convertDate2Time } from "./functions";
import { OUTER_BOOK_TYPE, INTERNAL_TYPE } from "./enviroments";


export const cancelBookingMail = async (functions: any, booking: KV, doctor: KV, external: KV[], internal: KV[]) => {
    let doctorEmail = ""
    if (doctor) {
        doctorEmail = doctor.email;
    }
    if ((booking.bookingType === OUTER_BOOK_TYPE || booking.bookingType === INTERNAL_TYPE) && doctorEmail) {
        // メールパラメータ設定
        let emailModality: any = {};
        emailModality['execTimeRange'] = `${convertDate2Time(booking.start as Date)} ~ ${convertDate2Time(booking.end as Date)}`;
        emailModality['id'] = booking.modalityID;
        emailModality['body2'] = booking.body2;
        emailModality['contrast'] = booking.contrast;

        let hospitals: any = {};
        hospitals["clinic_name"] = booking.clinicName;
        hospitals["doctor_name"] = booking.doctor;
        hospitals["department"] = booking.department;

        const toExternals: string[] = [];
        const toInternals: string[] = [];

        if (external && external.length > 0) {
            const user = external[0];
            toExternals.push(user.email);
        }
        // 院内(通知設定しているユーザー)
        if (internal && Array.isArray(internal)) {
            internal.forEach((user: KV) => {
                toInternals.push(user.email);
            });
        }

        const params: KV = {
            doctor: booking.doctor as string,
            bookNo: booking._id as string,
            bookDate: convertDate(new Date(booking.start || new Date()) as Date),
            receptTime: booking.checkin as string,
            weight: booking.weight,
        }

        await sendCancelToExternal(functions, toExternals, params, emailModality);
        await sendCancelToInternal(functions, toInternals, params, emailModality, hospitals);
    }
}